export interface DriverGreeting {
  greeting: string;
  driverName: string;
  subtitle: string;
  vehicleAssigned: string;
  shiftDate: string;
  territory: string;
  status: 'Online' | 'Offline';
}

export interface RouteStat { id: string; label: string; value: string }

export interface RouteOverview {
  routeId: string;
  date: string;
  description: string;
  status: 'READY TO START' | 'IN PROGRESS' | 'COMPLETED';
  stats: RouteStat[];
}

export interface CollectionSummaryItem {
  id: string;
  label: string;
  value: string;
  variant: 'green' | 'blue' | 'orange' | 'dark';
}

export interface DashboardAlert {
  id: string;
  title: string;
  description: string;
  timeAgo: string;
  variant: 'error' | 'warning' | 'info';
}

export function timeOfDayGreeting(): string {
  const h = new Date().getHours();
  if (h < 12) return 'GOOD MORNING';
  if (h < 18) return 'GOOD AFTERNOON';
  return 'GOOD EVENING';
}
